import React from "react";
import Heading from "../../components/common/Typography/Heading";
import { businessCategories } from "../Home/BusinessCategories";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { Link } from "react-router-dom";
import { classNames } from "primereact/utils";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_BLOG_LAYOUT_COLUMN_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SERVICES_GUIDE_TITLE_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";
import { getServiceGuidePath } from "../../utils/serviceGuideSlugs";

const AllServicesLayout = () => {
  const sortedLatestData = businessCategories.sort((a, b) => {
    if (a.businessCategoryName < b.businessCategoryName) return -1;
    if (a.businessCategoryName > b.businessCategoryName) return 1;
    return 0;
  });
  const handleItemSelect = (id) =>
    document
      .getElementById(`service-${id}`)
      .scrollIntoView({ block: "start", behavior: "smooth" });
  return (
    <>
      <div className="tp-container-main mx-auto w-full">
        <Heading
          variant={"h1"}
          className={`text-center ${publicMainHeaderOffsetClass()} text-offblack`}
        >
          Comprehensive service guide
        </Heading>
        <div className={`flex ${PUBLIC_BLOG_LAYOUT_COLUMN_GAP_CLASS} ${PUBLIC_SERVICES_GUIDE_TITLE_GAP_CLASS}`}>
          <div className="w-full lg:flex flex-col items-start mt-[75px] hidden">
            <AuxiliaryText
              variant={"MenuDropdown"}
              className={
                "mb-5 text-offblack border-b border-b-mediumgray w-full pb-4 font-semibold"
              }
            >
              All Categories
            </AuxiliaryText>
            {sortedLatestData
              .sort((a, b) =>
                a.businessCategoryName.localeCompare(b.businessCategoryName)
              )
              .map((e) => {
                return (
                  <button
                    key={e.id}
                    type="button"
                    onClick={() => handleItemSelect(e.businessCategoryName)}
                  >
                    <AuxiliaryText
                      variant={"SubMenuDropdown"}
                      className={"mb-2 hover:text-primaryblue"}
                    >
                      {e.businessCategoryName}
                    </AuxiliaryText>
                  </button>
                );
              })}
          </div>
          <div>
            {sortedLatestData
              .sort((a, b) =>
                a.businessCategoryName.localeCompare(b.businessCategoryName)
              )
              .map((item, index) => {
                return (
                  <>
                    <div
                      id={`service-${item.businessCategoryName}`}
                      className={classNames({
                        [PUBLIC_HEADING_TO_CONTENT_CLASS]: index > 0,
                      })}
                    >
                      <Heading variant={"h5"} className={"text-offblack"}>
                        {item?.businessCategoryName}
                      </Heading>
                      <div className={`shrink-0 h-auto 2xl:h-[600px] aspect-[900/600] ${PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}`}>
                        <Link to={getServiceGuidePath(item.slug)}>
                          <img
                            src={require("../../../src/assets/img/default-image.jpg")}
                            className="rounded-xl w-full h-full object-cover"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllServicesLayout;
